import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from '../../login/login.service';
import { firstValueFrom } from 'rxjs';
import { ColectiveAgreement } from '../../common/_types/colective-agreement';
import { ColectiveAgreementsService } from '../../common/_services/colective-agreements.service';

@Component({
    selector: 'app-colective-agreement-detail',
    templateUrl: './colective-agreement-detail.component.html',
    styleUrls: ['./colective-agreement-detail.component.scss'],
    standalone: false
})
export class ColectiveAgreementDetailComponent {
  public colectiveAgreementFormGroup!: RxFormGroup;

  public colectiveAgreement: any = new ColectiveAgreement();

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private colectiveAgreementsService: ColectiveAgreementsService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService,
  ) {

    this.colectiveAgreementFormGroup = this.formBuilder.formGroup<ColectiveAgreement>(this.colectiveAgreement) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalle de acuerdo colectivo");
    this.topbarService.addBreadcrumb("Acuerdos colectivos", "/colective-agreements");
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadColectiveAgreement(id);
    } 

    this.allowWrite = this.loginService.hasPermission("COLECTIVE_AGREEMENT.WRITE")
    this.allowDelete = this.loginService.hasPermission("COLECTIVE_AGREEMENT.DELETE")

  }

  async loadColectiveAgreement(id: string) {
    this.colectiveAgreement = await firstValueFrom(this.colectiveAgreementsService.get(id));
    this.colectiveAgreementFormGroup.patchValue(this.colectiveAgreement);
  }


  async save() {
    let valid = this.formValidationService.validateForm(this.colectiveAgreementFormGroup);
    if (valid) {
      this.colectiveAgreement = Object.assign(this.colectiveAgreement, this.colectiveAgreementFormGroup.value);
      let colectiveAgreement = await firstValueFrom(this.colectiveAgreementsService.save(this.colectiveAgreement));
      this.messageService.add({ closable: true, severity: 'success', summary: "Convenio colectivo guardado correctamente." });
      this.router.navigate(['colective-agreements']);
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el convenio colectivo?",
      header: "Eliminar convenio colectivo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.colectiveAgreementsService.delete(this.colectiveAgreement.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Convenio colectivo eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['colective-agreements']);
  }
}
